// Categorias Centrais da Aplicação

export const PRACTICE_AREAS = [
  { id: 'worker', translationKey: 'worker' },
  { id: 'corporate', translationKey: 'corporate' },
  { id: 'condominium', translationKey: 'condominium' }
];

export const FAQ_CATEGORIES = [
  'Direito do Trabalho para Trabalhadores',
  'Direito do Trabalho para Empresas',
  'Direito Condominial'
];

export const BLOG_CATEGORIES = [
  'Direitos do Trabalhador',
  'Gestão & Empresas',
  'Vida em Condomínio'
];

export const CONTACT_AREAS = [
  'Meus direitos trabalhistas',
  'Segurança trabalhista para minha empresa',
  'Assuntos condominiais',
  'Outro assunto'
];
